import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stack,
} from "@mui/material";

const defaults = {
  name: "",
  code: "",
  deliveryDays: "",
  mode: "Surface",
};

const ServiceDialog = ({ open, onOpenChange, onSubmit, initial, title }) => {
  const [form, setForm] = useState(initial || defaults);

  const handleOpen = () => setForm(initial || defaults);

  const handleSubmit = () => {
    if (!form.name.trim() || !form.code.trim()) return;
    onSubmit(form);
    onOpenChange(false);
  };

  return (
    <Dialog
      open={open}
      onClose={() => onOpenChange(false)}
      slotProps={{ transition: { onEnter: handleOpen } }}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            label="Service Name *"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            size="small"
            fullWidth
            slotProps={{ htmlInput: { maxLength: 100 } }}
          />
          <TextField
            label="Code *"
            value={form.code}
            onChange={(e) =>
              setForm({ ...form, code: e.target.value.toUpperCase() })
            }
            size="small"
            fullWidth
            slotProps={{ htmlInput: { maxLength: 10 } }}
          />
          <TextField
            label="Delivery Days"
            value={form.deliveryDays}
            onChange={(e) =>
              setForm({ ...form, deliveryDays: e.target.value })
            }
            size="small"
            fullWidth
            placeholder="e.g. 2-3 days"
            slotProps={{ htmlInput: { maxLength: 20 } }}
          />
          <FormControl size="small" fullWidth>
            <InputLabel>Mode</InputLabel>
            <Select
              value={form.mode}
              label="Mode"
              onChange={(e) => setForm({ ...form, mode: e.target.value })}
            >
              <MenuItem value="Air">Air</MenuItem>
              <MenuItem value="Surface">Surface</MenuItem>
              <MenuItem value="Express">Express</MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={!form.name.trim() || !form.code.trim()}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ServiceDialog;
